export function Badge({ value }: { value: string }) {
  return (
    <div
      className="
        center-text
        focus:ring-ring
        inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold
        text-secondary-foreground transition-colors ease-[var(--ease-standard)]
        hover:bg-secondary/80
        focus:ring-2 focus:ring-offset-2 focus:outline-none
      "
    >
      {value}
    </div>
  )
}
